var _style, _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareVideoUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.09449 60.09449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * { stroke-width: 0px; }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.14633,
    y: 9.12141,
    width: 43.86898,
    height: 43.86898,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-13.14937 30.36641) rotate(-45)",
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.72245,
    y: 8.3939,
    width: 40.66394,
    height: 40.66394,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-11.50952 29.66529) rotate(-45)",
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.05792,16.28871l-5.53036-5.62033c-.78147-.80176-2.17563-.78529-2.97395.0064,0,0-5.63401,5.63409-5.63401,5.63409-1.85046,1.86451.97495,4.70065,2.84535,2.84519-.00008.0001,2.3166-2.31661,2.3166-2.31661v14.6381c0,1.11119.90093,2.01214,2.01211,2.01214,1.11167,0,2.01162-.90094,2.01162-2.01214v-14.48206c.81362.66658,2.29668,2.8746,3.51818,2.71871,1.71479.05987,2.70136-2.22275,1.43446-3.42348Z",
    fill: "#82368c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_302",
    d: "M41.10923,22.5854h-21.7147c-1.06808-.05043-1.97773.76827-2.0397,1.83573v14.68587c.06197,1.06747.97163,1.88616,2.0397,1.83573h21.40874c1.06808.05043,1.97773-.76826,2.0397-1.83573v-14.68587c.02404-.98411-.74987-1.80355-1.73375-1.83573h.00001ZM33.15438,23.50326h4.07941v1.83573h-4.07941v-1.83573ZM22.95586,23.50326h4.07941v1.83573h-4.07125l-.00816-1.83573ZM18.36652,24.42113c-.00314-.50691.40525-.92039.91216-.92353.03598-.00022.07193.00167.10769.00567h2.55779v1.83573h-3.56948s-.00816-.91787-.00816-.91787ZM21.94416,40.02487h-2.54963c-.50378.05634-.95785-.30639-1.01418-.81018-.004-.03575-.00589-.07171-.00567-.10769v-.91787h3.56948v1.83574ZM27.04343,40.02487h-4.07941v-1.83574h4.07941v1.83574ZM32.14269,40.02487h-4.07941v-1.83574h4.07941v1.83574ZM37.24195,40.02487h-4.07941v-1.83574h4.07941v1.83574ZM41.83129,39.107c.00314.50691-.40525.9204-.91217.92354-.03597.00022-.07193-.00167-.10769-.00567h-2.54963v-1.83574h3.56948s0,.91787,0,.91787ZM41.83129,37.27127h-23.4566v-11.01441h23.44845l.00816,11.01441h-.00001ZM41.83129,25.339h-3.56948v-1.83574h2.54963c.50378-.05633.95785.30639,1.01418.81018.004.03575.00589.07171.00567.10769,0,0,0,.91787,0,.91787Z",
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareVideoUpIcon);
export default __webpack_public_path__ + "static/media/ShareVideoUpIcon.a37aa5c2259fc0d7437c2c5ace504470.svg";
export { ForwardRef as ReactComponent };